export default __webpack_public_path__ + "fb76bf03557580040323d70a84397acc.svg";